export const getUserIdFromSub = sub => sub.split(':').pop();

export const USER_REQUEST_SCOPE = 'openid email profile';

class User {
  constructor(
    {
      email,
      userId,
      username,
      expires,
      sub,
      name,
      iat: issuedAt,
      exp: expirationTime,
      userIdEncrypted,
      emailEncrypted,
      picture,
      'ecg:id:external_origin': externalOrigin,
      externalAuthProvider,
    } = {
      email: '',
      userId: '',
      username: '',
      name: '',
      expires: 0,
      userIdEncrypted: '',
      emailEncrypted: '',
      picture: '',
    }
  ) {
    if (expirationTime) {
      this.initializeFromJWT({
        email,
        sub,
        name,
        issuedAt,
        expirationTime,
        userIdEncrypted,
        emailEncrypted,
        picture,
        externalOrigin,
      });
    } else {
      this.initialize({
        email,
        userId,
        username,
        expires,
        userIdEncrypted,
        emailEncrypted,
        picture,
        externalAuthProvider,
      });
    }

    return this;
  }

  initialize({
    email,
    userId,
    username,
    expires,
    userIdEncrypted,
    emailEncrypted,
    picture,
    externalAuthProvider,
  }) {
    this.email = email;
    this.userId = userId;
    this.username = username;
    this.expires = expires;
    this.userIdEncrypted = userIdEncrypted;
    this.emailEncrypted = emailEncrypted;
    this.picture = picture;
    this.externalAuthProvider = externalAuthProvider || null;
  }

  initializeFromJWT({
    sub,
    name,
    email,
    expirationTime,
    userIdEncrypted,
    emailEncrypted,
    picture,
    externalOrigin,
  }) {
    this.email = email;
    this.userId = getUserIdFromSub(sub);
    this.username = name;
    this.expires = expirationTime * 1000;
    this.userIdEncrypted = userIdEncrypted;
    this.emailEncrypted = emailEncrypted;
    this.picture = picture;
    this.externalAuthProvider = externalOrigin || null;
  }

  toJSON() {
    return {
      email: this.email,
      userId: this.userId,
      username: this.username,
      expires: this.expires,
      userIdEncrypted: this.userIdEncrypted,
      emailEncrypted: this.emailEncrypted,
      picture: this.picture,
      externalAuthProvider: this.externalAuthProvider || null,
    };
  }

  isLoggedIn() {
    return Boolean(this.userId);
  }
}

export default User;
